import React, { useState, /*useContext,*/ useEffect, useCallback } from 'react';
import { forgotPassword, validateOtp, resetPassword } from 'lib/api';
import { LoginHero, Otp, PasswordReset } from 'components/atomic/molecules';
// import { LevelContext } from 'components/contexts/LevelContext';
import { validateOtpCode, validdateEmail } from 'utils/validation';
import { Form, Button, Alert } from 'react-bootstrap';
import { ArrowDownDark, ConfirmSolid } from '@icons';
import { MailToSupportLink } from '@components/atomic/atoms';
import { useHistory } from 'react-router-dom';

// Component
const ResetPasswordForm = () =>
	// { setShowLogin }
	{
		const history = useHistory();
		const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; // eslint-disable-line

		// Context
		// const { setEmailForPasswordReset, emailForPasswordReset } = useContext(LevelContext);

		const emailForPasswordReset = localStorage.getItem('emailForPasswordReset') || '';
		const setEmailForPasswordReset = (email) => {
			localStorage.setItem('emailForPasswordReset', email);
		};

		// State management
		const [resetPasswordForm, setResetPasswordForm] = useState({
			email: '',
			otpCode: '',
			password: '',
			passwordConfirmation: '',
		});
		const [isLoading, setIsLoading] = useState(false);
		const [error, setError] = useState({ show: false, message: '', title: '' });

		const shouldGoToOtp = emailForPasswordReset !== '';

		// const [showOtp, setShowOtp] = useState(shouldGoToOtp);
		// const [showPass, setShowPass] = useState(false);
		// const [successReset, setSuccessReset] = useState(false);

		const [currentStep, setCurrentStep] = useState(
			shouldGoToOtp ? 'otp' : 'email',
			// 'success',
		); // "email", "otp", "otpSuccess", "reset", "success"

		// Event handlers
		const handleClick = async (e) => {
			// const email = showOtp ? (emailForPasswordReset !== '' ? emailForPasswordReset : resetPasswordForm.email) : resetPasswordForm.email;
			const email = shouldGoToOtp ? emailForPasswordReset : resetPasswordForm.email;
			if (validdateEmail(email)) {
				setIsLoading(true);
				await forgotPassword(email).then((resp) => {
					if (resp.success) {
						// setError({
						// 	show: true,
						// 	message: 'Codice OTP inviato con successo',
						// 	title: 'Successo',
						// });
						setIsLoading(false);
						setResetPasswordForm({ ...resetPasswordForm, email: email });
						// setShowOtp(true);
						setCurrentStep('otp');
					} else {
						setIsLoading(false);
						let message = '';
						if (resp.data === undefined) {
							message = resp.message;
							// setShowOtp(true);
							setEmailForPasswordReset(email);
							setResetPasswordForm({ ...resetPasswordForm, email: email });
						} else {
							// Check if data is an object
							if (typeof resp.data === 'object') {
								for (let key in resp.data) {
									message += resp.data[key] + ' ';
								}
							}
						}
						setError({
							show: true,
							message: message,
							title: 'Errore',
						});
					}
				});
			} else {
				setError({
					show: true,
					message: 'Email o password non validi',
					title: 'Errore',
				});
			}
		};

		const handleValidateOtp = useCallback(
			async (e) => {
				// const email = showOtp ? (emailForPasswordReset !== '' ? emailForPasswordReset : resetPasswordForm.email) : resetPasswordForm.email;
				const email = shouldGoToOtp ? emailForPasswordReset : resetPasswordForm.email;

				if (validateOtpCode(resetPasswordForm.otpCode) && validdateEmail(email)) {
					setIsLoading(true);
					await validateOtp(email, resetPasswordForm.otpCode).then((resp) => {
						if (resp.success) {
							// setError({
							// 	show: true,
							// 	message: 'Codice OTP valido',
							// 	title: 'Successo',
							// });
							setIsLoading(false);
							// setShowPass(true);
							// setShowOtp(false);
							setResetPasswordForm({
								email: email,
								otpCode: resetPasswordForm.otpCode,
							});
							// setCurrentStep('reset');
							setCurrentStep('otpSuccess');
						} else {
							setIsLoading(false);
							let message = '';
							if (resp.data === undefined) {
								message = resp.message;
							} else {
								// Check if data is an object
								if (typeof resp.data === 'object') {
									for (let key in resp.data) {
										message += resp.data[key] + ' ';
									}
								}
							}
							setError({
								show: true,
								message: message,
								title: 'Errore',
							});
						}
					});
				} else {
					setError({
						show: true,
						message: 'Codice OTP non valido',
						title: 'Errore',
					});
				}
			},
			[resetPasswordForm, shouldGoToOtp, emailForPasswordReset],
		);

		useEffect(() => {
			// if (!showOtp) return;
			if (currentStep !== 'otp') return;
			if (resetPasswordForm.otpCode.length === 6) {
				handleValidateOtp();
			}
		}, [currentStep, handleValidateOtp, resetPasswordForm.otpCode]);

		const handlePasswordReset = async (e) => {
			if (resetPasswordForm.password === '') {
				setError({
					show: true,
					message: 'Inserisci la password',
					title: 'Errore',
				});
				return;
			}

			if (resetPasswordForm.passwordConfirmation === '') {
				setError({
					show: true,
					message: 'Conferma la password',
					title: 'Errore',
				});
				return;
			}

			if (resetPasswordForm.password !== resetPasswordForm.passwordConfirmation) {
				setError({
					show: true,
					message: 'Le password non corrispondono',
					title: 'Errore',
				});
				return;
			}

			if (!passwordRegex.test(resetPasswordForm.password)) {
				setError({
					show: true,
					message:
						'La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale',
					title: 'Errore',
				});
				return;
			}

			setIsLoading(true);
			await resetPassword(
				resetPasswordForm.email,
				resetPasswordForm.password,
				resetPasswordForm.passwordConfirmation,
				resetPasswordForm.otpCode,
			).then((resp) => {
				if (resp.success) {
					// setError({
					// 	show: true,
					// 	message: 'Password cambiata con successo',
					// 	title: 'Successo',
					// });
					setIsLoading(false);
					setEmailForPasswordReset('');
					// reset all state
					setResetPasswordForm({
						email: '',
						otpCode: '',
						password: '',
						passwordConfirmation: '',
					});
					setCurrentStep('success');
					// setShowOtp(false);
					// setShowPass(true);
					// setSuccessReset(true);
				} else {
					setIsLoading(false);
					let message = '';
					if (resp.data === undefined) {
						message = resp.message;
					} else {
						// Check if data is an object
						if (typeof resp.data === 'object') {
							for (let key in resp.data) {
								message += resp.data[key] + ' ';
							}
						}
					}
					setError({
						show: true,
						message: message,
						title: 'Errore',
					});
				}
			});
		};

		return (
			<div
				className="m-0"
				style={{
					display: 'grid',
					gridTemplateColumns: 'repeat(auto-fit, minmax(50%, 1fr))',
					height: '100%',
					justifyContent: 'center',
				}}
			>
				<LoginHero />

				<div
					className="d-flex flex-column justify-content-center"
					style={{ maxWidth: '472px', width: '100%', margin: '0 auto', padding: '1rem' }}
				>
					<Alert
						className="text-start"
						// variant={error.title === 'Errore' ? 'danger' : 'success'}
						variant="danger"
						onClose={() => setError({ show: false })}
						dismissible
						show={error.show}
					>
						<Alert.Heading
							style={{
								fontSize: '15px',
								fontWeight: '600',
								lineHeight: '15.6px',
								// fontFamily: 'Barlow',
							}}
						>
							{error.title}
						</Alert.Heading>
						<p
							style={{
								fontSize: '15px',
								fontWeight: '300',
								lineHeight: '18px',
								// fontFamily: 'Barlow',
							}}
						>
							{error.message}
						</p>
					</Alert>

					{currentStep === 'email' ? (
						<div>
							<h5
								style={{
									fontSize: '32px',
									fontWeight: 700,
									lineHeight: '28.8px',
								}}
								className="pb-3"
							>
								Hai dimenticato la password?
							</h5>
							<p>Inserisci il tuo indirizzo email e ti invieremo un codice per reimpostare la password.</p>

							<Form>
								<Form.Group className="mb-4">
									<Form.Label htmlFor="email">Indirizzo e-mail</Form.Label>
									<Form.Control
										// className="text-center"
										type="email"
										name="email"
										value={resetPasswordForm.email}
										placeholder="Inserisci indirizzo e-mail"
										onChange={({ target: { value } }) =>
											setResetPasswordForm({
												...resetPasswordForm,
												email: value,
											})
										}
									/>
								</Form.Group>
								<Button
									disabled={isLoading || resetPasswordForm.email === ''}
									onClick={(e) => {
										handleClick(e);
									}}
									// variant="info"
									className="btn custom-primary-button"
									style={{
										width: '100%',
									}}
									type="button"
								>
									{isLoading ? 'Caricamento...' : 'Invia codice'}
								</Button>
							</Form>
						</div>
					) : null}

					{currentStep === 'otp' ? (
						<>
							<Otp
								email={resetPasswordForm.email}
								handleClick={handleClick}
								isLoading={isLoading}
								onInputChange={(otp) => {
									setResetPasswordForm({
										...resetPasswordForm,
										otpCode: otp,
									});
								}}
							/>
						</>
					) : null}

					{currentStep === 'otpSuccess' ? (
						<div
							style={{
								textAlign: 'center',
							}}
						>
							<ConfirmSolid />
							<h5
								style={{
									fontSize: '32px',
									fontWeight: 700,
									lineHeight: '28.8px',
									marginTop: '2rem',
								}}
								className="pb-3"
							>
								OTP verificato con successo
							</h5>
							<p>Hai completato correttamente la verifica tramite codice OTP. Reimposta la password per accedere.</p>
							<Button
								onClick={() => {
									setCurrentStep('reset');
								}}
								className="btn custom-primary-button"
								style={{
									width: '100%',
								}}
							>
								Reimposta password
							</Button>
						</div>
					) : null}

					{currentStep === 'reset' ? (
						<div>
							<PasswordReset
								resetPasswordForm={resetPasswordForm}
								setResetPasswordForm={setResetPasswordForm}
								handleResetPassword={handlePasswordReset}
							/>
						</div>
					) : null}

					{currentStep === 'success' ? (
						<div
							style={{
								textAlign: 'center',
							}}
						>
							<ConfirmSolid />
							<h5
								style={{
									fontSize: '32px',
									fontWeight: 700,
									lineHeight: '28.8px',
									marginTop: '2rem',
								}}
								className="pb-3"
							>
								Password reimpostata con successo
							</h5>
							<p>Ora puoi effettuare il login con la tua nuova password.</p>
							<Button
								onClick={() => {
									history.push('/');
								}}
								className="btn custom-primary-button"
								style={{
									width: '100%',
								}}
							>
								Accedi
							</Button>
						</div>
					) : null}

					{currentStep !== 'success' ? (
						<div>
							<p
								style={{
									marginTop: '1rem',
									textAlign: 'center',
									marginBottom: '1rem',
								}}
							>
								Per assistenza <MailToSupportLink />.
							</p>
							{/* <p
									style={{
										fontSize: '18px',
										fontWeight: '400',
										lineHeight: '24px',
										// fontFamily: 'Barlow',
									}}
									className="pt-3"
								>
									Hai già un account?{' '} */}
							<Button
								disabled={isLoading}
								onClick={() => {
									// setShowLogin(true);
									history.push('/');
									setEmailForPasswordReset('');
								}}
								className="btn custom-ghost-button"
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: '0.5rem',
									textTransform: 'none',
									fontWeight: 500,
									marginTop: '2rem',
								}}
							>
								<ArrowDownDark
									style={{
										rotate: '90deg',
										// width: '24px',
										height: '16px',
									}}
								/>
								<span>Torna al login</span>
							</Button>
							{/* </p> */}
						</div>
					) : null}
				</div>
			</div>
		);
	};

export default ResetPasswordForm;
